import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[npaButtonSpinner]'
})
export class ButtonSpinnerDirective {
  @Input()
  set on(on: boolean) {
    if (on) {
      const _elementRect: ClientRect | DOMRect = this._element.getBoundingClientRect();
      this._elementClassList = Array.from(this._element.classList);
      this._element.style.width = `${_elementRect.width}px`;
      this._element.style.height = `${_elementRect.height}px`;
      this._element.classList.remove('npa-button--icon-left', 'npa-button--icon-right');
      this._element.classList.add('no-events');
    } else {
      this._element.style.width = '';
      this._element.style.height = '';
      this._element.classList.remove('no-events');
      if (!!this._elementClassList) {
        this._element.classList.add(...this._elementClassList);
      }
    }
    this._on = on;
  }
  get on(): boolean {
    return this._on;
  }

  private _element: HTMLElement;
  private _elementClassList: Array<string>;
  private _on: boolean;

  constructor(private _el: ElementRef<HTMLElement>) {
    this._element = _el.nativeElement;
  }
}
